export default "__VITE_ASSET__UPlJuHS1__"